export default __webpack_public_path__ + "static/media/indices.a8693dfd.jpeg";